<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"
          :isSaving="isSaving"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import formEdit from "./add";
import ApiRepository from "@/core/ApiRepository";

export default {
  components: {
    formEdit,
  },
  data() {
    return {
      title: "Create",
      mode: "add",
      models: {},
      isSaving: false,
      componentKey: 0,
      page_transaction: null,
      time_zone_local: moment.tz.guess(true),
    };
  },
  async mounted() {
    this.mode = this.$route.name === "community_board_edit" ? "edit" : "add";
    this.title = this.mode === "edit" ? "Edit" : "Create";
    if (!this.$commonFuction.isEmpty(this.$route.query?.page_transaction)) {
      this.page_transaction = this.$route.query.page_transaction;
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_COMMUNITY_BOARD);
    if (this.mode === "edit") {
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
        return;
      }
    } else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
        return;
      }
    }
    await this.getData(this.$route.params.id);
  },
  methods: {
    async getData(id = null) {
      try {
        const headers = {
          Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
        };
        const response = this.mode === "add"
          ? await ApiRepository.post(
            "/_api/property/get_info_create_community_board_admin",
            {},
            { headers }
          )
          : await ApiRepository.post(
            "/_api/property/detail_community_board_admin",
            { id: id ?? null },
            { headers }
          );
        this.models = response?.data?.data ?? response?.data ?? {};
        this.componentKey++;
      } catch (err) {
        const error = err?.response?.data ?? null;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: `Exception error [${error?.message || "LOAD_COMMUNITY_BOARD_FAILED"}]`,
          life: 3000,
        });
      }
    },
    async saveData(params) {
      if (this.isSaving) {
        return;
      }
      try {
        this.isSaving = true;
        const headers = {
          Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
        };
        await ApiRepository.post(
          "/_api/property/save_community_board_admin",
          params,
          { headers }
        );
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: "Saved data successfully",
          life: 3000,
        });
        this.redirectEdit();
      } catch (err) {
        const error = err?.response?.data ?? null;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: `Exception error [${error?.message || "SAVE_COMMUNITY_BOARD_FAILED"}]`,
          life: 3000,
        });
      } finally {
        this.isSaving = false;
      }
    },
    backToList() {
      this.redirectEdit();
    },
    redirectEdit() {
      const router_back = { path: "/admin/list-community_board" };
      if (this.mode === "add") {
        this.$router.push(router_back);
        return;
      }
      if (!this.$commonFuction.isEmpty(this.page_transaction)) {
        router_back.query = { page_transaction: this.page_transaction.toString() };
      }
      this.$router.push(router_back);
    },
  },
};
</script>

<style lang="scss">
.manager-title-custom {
  color: #1d3118;
  font-size: 24px !important;
  padding-bottom: 20px;
  font-weight: 700;
  margin-left: 20px;
}
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 150px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 10px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.manager-title-row{
  border-bottom: 1px solid #EEEEEE;
}
.p-toolbar-group-right {
  flex-basis: 30%;
}
.p-button-warning.p-button {
  margin: 0 10px;
}
</style>
